import { useDictionaryContext } from "@/components/dictionaries/DictionaryContext";
import Spinner from "@/components/Spinner";
import { useTranslation } from "react-i18next";

export default function DictionaryLoader() {
  const { config } = useDictionaryContext();
  const { t } = useTranslation();
  const labels = config.getLabels(t);

  return <Spinner label={labels.loading} className="w-full h-full " />;
}
